module.exports = __webpack_public_path__ + "/images/logo-cta-mundo-financiero.91fbe0b.png";